import React from "react";
import image from "../assets/images/image (2).png";

const RealEstateOverview = ({ aboutData, btnshown }) => {
  return (
    <div
      className=""
      style={{
        backgroundColor: "#FFE500",
        borderRadius: "30px",
        margin: "20px",
      }}
    >
      <div className="container px-4 py-4 text-black">
        <div className="row">
          <div className="order-2 order-lg-1 mt-5 mt-lg-0  col-lg-6 px-4 d-flex justify-content-center align-items-center">
            <div className="">
              <p className="font-face-PlusJakartaSans-Bold">About Us</p>
              <h1 className="font-face-PlusJakartaSans-Bold">
                {aboutData.heading}
              </h1>
              <div className="d-flex gap-2 mt-4">
                <div>
                  <p
                    className="font-face-PlusJakartaSans-Regular"
                    style={{ fontSize: "20px" }}
                  >
                    {aboutData.content}
                  </p>

                  <p className="font-face-PlusJakartaSans-Regular">
                    {aboutData.contentTwo}
                  </p>

                  {btnshown ? (
                    <a
                      href="https://apps.apple.com/us/app/realtybase/id1581598890"
                      target="_blank"
                    >
                      <button
                        className="btnTwo font-face-PlusJakartaSans-Bold"
                        style={{ color: "black" }}
                      >
                        Download Now
                      </button>
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-flex justify-content-center align-items-center  order-1 order-lg-2">
            <img src={image} className="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealEstateOverview;
